export default __webpack_public_path__ + "static/media/img/bg-design.webp";